import React from 'react';
import Layout from '../components/Layout';
import CustomerForm from '../components/CustomerForm';
import { useParams } from 'react-router-dom';

const EditCustomer = () => {
  const { customerId } = useParams();
  
  return (
    <Layout>
      <CustomerForm mode="edit" customerId={customerId} />
    </Layout>
  );
};

export default EditCustomer;
